(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["responsive-image"] && !Shopify.designMode) return;
  try {
    (function () {
    class ResponsiveImageLoader {
      constructor() {
        this.inEditor = window.Shopify?.designMode;
        this.observer = this.inEditor
          ? null
          : new IntersectionObserver(this.onIntersect.bind(this), {
              rootMargin: '200px 0px',
            });

        this.scan(document);
        document.addEventListener('shopify:section:load', (e) => this.scan(e.target));
        window.responsiveImageLoader = this;
      }

      scan(root) {
        root.querySelectorAll('img[data-responsive-image]').forEach((img) => {
          if (this.inEditor) {
            this.upgrade(img);
          } else {
            this.observer.observe(img);
          }
        });
      }

      rescan(root) {
        this.scan(root);
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.upgrade(entry.target);
          this.observer.unobserve(entry.target);
        });
      }

      upgrade(img) {
        img.removeAttribute('hidden');
        const rect = img.getBoundingClientRect();
        if (!rect.width) return;

        const isMobile = !window.matchMedia('(min-width: 768px)').matches;
        const baseSrc =
          isMobile && img.dataset.mobileSrc ? img.dataset.mobileSrc : img.src;

        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const rawWidth = this.calcNeededWidth(img, rect, dpr);
        const maxWidth = parseInt(img.getAttribute('width')) || Infinity;
        const snapped = Math.ceil(Math.min(rawWidth, maxWidth) / 50) * 50;

        const newSrc = this.buildUrl(baseSrc, snapped);
        if (!newSrc || newSrc === img.src) {
          img.classList.add('rimg--loaded');
          return;
        }

        const preload = new Image();
        preload.onload = () => {
          img.src = newSrc;
          img.removeAttribute('srcset');
          img.classList.add('rimg--loaded');
        };
        preload.src = newSrc;
      }

      calcNeededWidth(img, rect, dpr) {
        const objectFit =
          img.dataset.objectFit || window.getComputedStyle(img).objectFit;
        const imageAR = parseFloat(img.dataset.imageAr);

        if (
          (objectFit === 'cover' || objectFit === 'contain') &&
          imageAR &&
          rect.height > 0
        ) {
          const containerAR = rect.width / rect.height;
          if (objectFit === 'cover') {
            // Image wider than container: height constrains, image extends horizontally
            return imageAR > containerAR
              ? Math.ceil(rect.height * imageAR * dpr)
              : Math.ceil(rect.width * dpr);
          }
          // contain: image letterboxed, the smaller dimension of the container constrains
          return imageAR > containerAR
            ? Math.ceil(rect.width * dpr)
            : Math.ceil(rect.height * imageAR * dpr);
        }

        return Math.ceil(rect.width * dpr);
      }

      buildUrl(src, width) {
        const resolved = src.startsWith('//') ? `${window.location.protocol}${src}` : src;
        let url;
        try {
          url = new URL(resolved);
        } catch {
          console.error('[responsive-image] Could not parse image URL:', src);
          return null;
        }

        if (!url.searchParams.has('width')) {
          console.error(
            '[responsive-image] Unexpected CDN URL format — no width param. Skipping upgrade:',
            src
          );
          return null;
        }

        url.searchParams.set('width', width);
        return url.toString();
      }
    }

    if (!window.responsiveImageLoader) {
      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          () => new ResponsiveImageLoader()
        );
      } else {
        new ResponsiveImageLoader();
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
